
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./logindesign.css";
import { useAuth } from './AuthContext';
import App from './App';
import LoginFailedModal from "./LoginFailedModal";
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginForm = () => {
  const history = useHistory();
  const { isAuthenticated, login } = useAuth();
  const [companyCode, setCompanyCode] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [branchId, setBranchId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginFailed, setLoginFailed] = useState(false);
  const [companyCodeValidated, setCompanyCodeValidated] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [branchstate,setbranchstate]=useState('');

  const handleCompanyValidation = async () => {
    try {
      // Implement company code validation logic here
      // For demonstration purposes, assume the company code is valid if it's not empty
      if (!companyCode.trim()) {
        //throw new Error('Company code is required.');
        toast.error('Branch code is required.', {
          position: toast.POSITION.TOP_CENTER,
        });
      }

      if (companyCode.trim()) {

        const CompanyData = {
          BranchCode: companyCode,
        };


        const response = await postLogin('BranchLoginApi', CompanyData);

        if (response.responseCode === '1111') {
          setCompanyCodeValidated(true);
          setCompanyId(response.response_data.companyId)
          setBranchId(response.response_data.id)
          setCompanyName(response.response_data.name);
          setbranchstate(response.response_data.branchstate)
          setLoginFailed(false); // Reset loginFailed state
        } else {
          //throw new Error(response.Message);
          toast.error('Invalid Branch code', {
            position: toast.POSITION.TOP_CENTER,
          });
        }

      }

    } catch (error) {
      toast.error("Branch login failed", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleLogin = async () => {
    try {

      if (!companyCodeValidated) {
        throw new Error('Branch code validation is required.');
      }

      const jwtToken = await performLogin();
      const responseData = jwtDecode(jwtToken);
      const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
      const permissions = Object.keys(responseData).filter(
        (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
      );

      let isSuper = false;
      if (responseData.isSuperAdmin.toLowerCase() === "true") {
        isSuper = true;
      }

      if (isSuper == false) {
        const parsedCompanyId = parseInt(responseData.companyId, 10);

        if (parsedCompanyId === companyId) {
          login(responseData.companyId,responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName,branchstate);
          const redirectParam = new URLSearchParams(location.search).get("redirect");
          const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
          history.replace(redirectPath);
        }
        else {
          toast.error('Invalid User !', {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
      else {
        login(responseData.companyId,responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName,branchstate);
        const redirectParam = new URLSearchParams(location.search).get("redirect");
        const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
        history.replace(redirectPath);
      }


    } catch (error) {
      toast.error('Login failed', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const performLogin = async () => {
    const loginData = {
      UserName: username,
      Password: password,
      CompanyId: companyId,
      BranchId: branchId
    };

    const response = await postLogin('LoginApi', loginData);

    if (response.responseCode === '1111') {
      const jwtToken = response.response_data.token;

      return jwtToken;
    } else {
      throw new Error(response.Message);
    }
  };

  const closeModal = () => {
    setLoginFailed(false);
  };

  if (isAuthenticated) {
    return <App />;
  }

  return (
    <div className="containers">
      <ToastContainer />
      <div className="login-boxs">
        <br />
        <h2 className="HEADING">LOGIN</h2>
        <br />

        {!companyCodeValidated && (
          <form onSubmit={(e) => {
            e.preventDefault();
            handleCompanyValidation();
          }}>
            <div className="cc">
              <label>BRANCH CODE</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                type="text"
                placeholder="Enter BRANCH code"
                value={companyCode}
                onChange={(e) => setCompanyCode(e.target.value)}
              />
            </div>
            <br />
            <button className="lgn" type="submit">
              Let Me In
            </button>
          </form>
        )}

        {companyCodeValidated && (
          <div>
            <p className="welcome-message">Welcome to {companyName}</p>
            <br />
            <form onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}>
              <div className="em">
                <label>USERNAME</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  type="text"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>

              <div className="pwd">
                <label>PASSWORD</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button className="lgn" type="submit">Login</button>
            </form>
          </div>
        )}
      </div>

      {loginFailed && <LoginFailedModal onClose={closeModal} />}
    </div>
  );
};

export default LoginForm;

